import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { useTheme } from './theme-provider';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const { theme } = useTheme();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
    setIsMenuOpen(false);
  };

  return (
    <nav className={`fixed w-full z-50 transition-all duration-300 ${
      isScrolled ? 'bg-brand-dark/95 backdrop-blur-md shadow-md' : 'bg-brand-dark'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo and Brand Name */}
          <div className="flex items-center">
            <img
              className="h-8 w-auto rounded"
              src="/images/logo.webp"
              alt="Develop in Rest"
            />
            <span className="ml-3 text-white font-medium text-lg font-serif">Develop in Rest</span>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-6">
            <button
              onClick={() => scrollToSection('hero')}
              className="text-white hover:text-coral-400 transition-colors duration-200 px-3 py-2 font-medium"
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="text-white hover:text-coral-400 transition-colors duration-200 px-3 py-2 font-medium"
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('case-studies')}
              className="text-white hover:text-coral-400 transition-colors duration-200 px-3 py-2 font-medium"
            >
              Case Studies
            </button>
            <button
              onClick={() => scrollToSection('chat')}
              className="text-white hover:text-coral-400 transition-colors duration-200 px-3 py-2 font-medium"
            >
              Chat
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="bg-coral-500 hover:bg-coral-600 text-white font-medium px-5 py-2 rounded-full transition-colors duration-200"
            >
              Contact Us
            </button>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="inline-flex items-center justify-center p-2 rounded-md text-white hover:text-coral-400 focus:outline-none"
            >
              {isMenuOpen ? (
                <X className="block h-6 w-6" />
              ) : (
                <Menu className="block h-6 w-6" />
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      <div className={`md:hidden ${isMenuOpen ? 'block' : 'hidden'}`}>
        <div className="px-2 pt-2 pb-3 space-y-1 bg-brand-dark/95 backdrop-blur-md">
          <button
            onClick={() => scrollToSection('hero')}
            className="block w-full text-left text-white hover:text-coral-400 px-3 py-2 text-base font-medium"
          >
            Home
          </button>
          <button
            onClick={() => scrollToSection('about')}
            className="block w-full text-left text-white hover:text-coral-400 px-3 py-2 text-base font-medium"
          >
            About
          </button>
          <button
            onClick={() => scrollToSection('case-studies')}
            className="block w-full text-left text-white hover:text-coral-400 px-3 py-2 text-base font-medium"
          >
            Case Studies
          </button>
          <button
            onClick={() => scrollToSection('chat')}
            className="block w-full text-left text-white hover:text-coral-400 px-3 py-2 text-base font-medium"
          >
            Chat
          </button>
          <button
            onClick={() => scrollToSection('contact')}
            className="block w-full text-left text-white hover:text-coral-400 px-3 py-2 text-base font-medium"
          >
            Contact
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
